import './styles/CookieBannerURL.scss';

import { useTranslation } from 'react-i18next';

import { useClassHelper } from '../../hooks/useClassHelper';
import { useCookiePolicy } from '../../hooks/useCookiePolicy';

const componentName = 'c-CookieBanner';

interface Props {
  imprintUrl?: string;
}

export const CookieBanner = ({ imprintUrl }: Props) => {
  const c = useClassHelper(componentName);
  const { t } = useTranslation();
  const { isCookieBanner } = useCookiePolicy();

  if (imprintUrl) {
    return (
      <div className={c('__imprint_url', { '__with-banner': isCookieBanner })}>
        <a target="_blank" href={imprintUrl} rel="noreferrer">
          {t('componentProfileMenu_imprint')}
        </a>
      </div>
    );
  }

  return null;
};
